import React from 'react'
import SearchBar from './search_bar'

const Search = () => {
    return (
        <>
            <SearchBar />
        </>
    )
}

export default Search



// WEBPACK FOOTER //
// ./src/m_header/components/search/index.js